import { render, staticRenderFns } from "./ivst_class.vue?vue&type=template&id=fe0b3184&scoped=true"
import script from "./ivst_class.vue?vue&type=script&lang=js"
export * from "./ivst_class.vue?vue&type=script&lang=js"
import style0 from "./ivst_class.vue?vue&type=style&index=0&id=fe0b3184&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe0b3184",
  null
  
)

export default component.exports